import script from "./LoadingPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingPopup.vue?vue&type=script&setup=true&lang=js"

import "./LoadingPopup.vue?vue&type=style&index=0&id=643cc5cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643cc5cc"]])

export default __exports__